import ECharts from "@/app/shared/components/chart/echarts";

export const getPartnerSearchTerm = (state) => {
  return state.partnerSearchTerm;
};

export const getPartnerInfo = (state) => {
  return state.partner_info;
};

export const getFilters = (state) => {
  return state.filters;
};

export const getActiveFilters = (state) => {
  let arrayFilters = state.filters
    .filter((item) => item.active?.length)
    .map((item) => {
      return {
        name: item.slug,
        value: item.active,
      };
    });

  let rangeFilters = state.filters
    .filter((item) => item.type === "range" && item.touched)
    .map((item) => {
      return {
        name: item.slug,
        from: item.from,
        to: item.to,
      };
    });

  let searchFilter = state.filters
    .filter((item) => item.type === "string" && item.value.length)
    .map((item) => {
      return {
        name: item.slug,
        value: item.value,
      };
    });
  return arrayFilters.concat(rangeFilters).concat(searchFilter);
};

export const getListMode = (state) => {
  return state.list_mode;
};

export const products = (state) => {
  const { products } = state;
  const stringArray = products.map((item) => JSON.stringify(item));
  const uniqueArray = new Array(...new Set(stringArray));
  const parsedArray = uniqueArray.map((item) => JSON.parse(item));
  return parsedArray;
};

export const query = (state) => {
  return state.query;
};

export const favorite = (state) => {
  return state.favorite;
};

export const chart_line = (state) => (value) => {
  let color_selected = " ";
  let color_line = " ";

  if (value[0] < value[value.length - 1]) {
    color_selected = "rgba(25, 214, 132, 0.5)";
    color_line = "#19D684";
  } else {
    color_selected = " rgba(235, 77, 75, 0.5)";
    color_line = "#e74c3c";
  }

  let option = {
    tooltip: {
      show: false,
      trigger: "axis",
      axisPointer: {
        type: "cross",
      },
    },
    grid: {
      left: "0%",
      right: "0%",
      bottom: "2%",
      top: "5%",
      width: "100%",
    },
    xAxis: {
      show: false,
      type: "category",
      boundaryGap: false,
      axisLabel: {
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: 10,
      },
      splitLine: {
        lineStyle: {
          color: "rgba(255, 255, 255, 0.2)",
        },
        show: false,
      },
    },
    yAxis: {
      type: "value",
      scale: true,
      nameTextStyle: {
        fontSize: 10,
        show: false,
      },
      axisLabel: {
        color: "rgba(255, 255, 255, 0.8)",
        fontSize: 10,
        inside: true,
        show: false,
        formatter: function (value) {
          value = value.toLocaleString("pt-BR", {
            minimumFractionDigits: 0,
          });
          return value;
        },
      },
      axisLine: {
        lineStyle: {
          color: "rgba(255, 255, 255, 0.2)",
          width: "1",
        },
        show: false,
      },
      splitLine: {
        lineStyle: {
          color: "rgba(255, 255, 255, 0.2)",
        },
        show: false,
      },
      minorSplitLine: {
        show: false,
      },
    },
    series: [
      {
        data: value,
        type: "line",
        lineStyle: {
          color: color_line,
          opacity: 1,
          width: 1.5,
        },
        symbol: "circle",
        symbolSize: 0,
        sampling: "average",
        itemStyle: {
          color: color_line,
        },
        areaStyle: {
          normal: {
            color: new ECharts.graphic.LinearGradient(0, 0, 0, 0.9, [
              {
                offset: 0,
                color: color_selected,
              },
              {
                offset: 1,
                color: "rgba(32, 42, 55, 0.4)",
              },
            ]),
          },
        },
      },
    ],
  };
  return option;
};
/**
 * Investimentos da conta demonstração.
 */
// export const accountDemo = ({ demo }) => {
//   demo.forEach(item => item.showPortfolio = false);
//   return demo;
// }
